import { useState, useEffect, useRef } from "react";
import { NavLink, Link } from "react-router-dom";
import { AiOutlineMenuUnfold, AiOutlineClose } from "react-icons/ai";
import Logo from "../../assets/svg/Logo.svg";
import { NavLinks } from "../../data/data";
import "./Header.scss";
import { RegisterBtn, RegisterBtnMobile } from "../../components/Button/Button";

const Header = () => {
  const [showLinks, setShowLinks] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [bgColor, setBgColor] = useState("transparent");
  const [shadow, setShadow] = useState("none");
  const navMenu = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setBgColor("var(--clr-primary-4");

        setShadow("var(--dark-shadow)");
      } else {
        setBgColor("transparent");
        setShadow("none");
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    showLinks
      ? navMenu.current.classList.add("show-menu")
      : navMenu.current.classList.remove("show-menu");
  }, [showLinks]);

  const toggleNav = () => {
    setShowLinks(!showLinks);
    setToggle(!toggle);
  };

  const navLinkClose = () => {
    setShowLinks(false);
    setToggle(!toggle);
  };

  return (
    <header
      className="nav"
      style={{ backgroundColor: bgColor, boxShadow: shadow }}
    >
      <nav className="nav__container container">
        <Link to="/" className="nav__logo">
          <img src={Logo} alt="Nav logo" />
        </Link>

        <div className="nav__menu" ref={navMenu}>
          <ul className="nav__list">
            {NavLinks.map((link) => {
              const { id, url, text } = link;
              return (
                <li className="nav__item" key={id}>
                  <NavLink
                    to={url}
                    className="nav__link"
                    onClick={navLinkClose}
                  >
                    {text}
                  </NavLink>
                </li>
              );
            })}
            <RegisterBtnMobile />
          </ul>
        </div>

        <RegisterBtn />

        <div className="nav__toggle">
          <button className="nav__btn" onClick={toggleNav}>
            {toggle ? <AiOutlineClose /> : <AiOutlineMenuUnfold />}
          </button>
        </div>
      </nav>
    </header>
  );
};

export default Header;
